import * as MC from "@mantine/core";
import { Fragment } from "react/jsx-runtime";

import { useAuthentication } from "@app/store/useAuthtentication";

import HomeLink from "@app/common/components/HomeLink";

export default function Selection() {
  const allCategories = useAuthentication((state) => state.auth.categories);

  const category = allCategories[0] || { modules: [] };

  const renderComponent = () => {
    return (
      <Fragment>
        <MC.Title className="display-1" c="brand-color" data-testid="selection-title" mb={30}>
          Módulo de Dispensación
        </MC.Title>

        {category?.modules &&
          category?.modules?.length > 0 &&
          category?.modules?.map((link) => (
            <HomeLink
              key={link.id}
              label={link.name}
              links={link.functionalities}
              data-testid={`selection-homelink-${link.name}`}
            />
          ))}

        <MC.Image
          src={category.categoryHomeImage}
          className="placeholder-image"
          w="40%"
          data-testid="selection-image"
        />
      </Fragment>
    );
  };

  return renderComponent();
}
